import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import LeftPanel from './Modules/LeftPanel';
import PackageList from './components/PackageList';
import PackageDetails from './components/PackageDetails';
import { useDestinations } from './data/dataComponent';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import './App.css';
import About from './Modules/About';
import ContactUs from './Modules/ContactUs';
import Header from './Modules/Header';

const App = () => {
  const [selectedDestinationId, setSelectedDestinationId] = React.useState(null);
  const [filteredDestinations, setFilteredDestinations] = React.useState([]);
  const [isCollapsed, setIsCollapsed] = React.useState(false);

  const { destinations, loading } = useDestinations();
  const location = useLocation();

  React.useEffect(() => {
    if (!loading && Array.isArray(destinations) && destinations.length > 0) {
      const validDestinations = destinations.filter(
        dest => dest && typeof dest === 'object' && 'id' in dest
      );
      setFilteredDestinations(validDestinations);
    }
  }, [destinations, loading]);

  const selectedDestination =
    selectedDestinationId && filteredDestinations.length > 0
      ? filteredDestinations.find(dest => dest && dest.id === selectedDestinationId)
      : null;

  return (
    <HelmetProvider>
      <div className="container mx-auto p-4 font-sans">
        <Helmet>
          <title>Tour Leh Ladakh</title>
        </Helmet>
        <Header />
        {loading ? (
          <div className="flex flex-col items-center mt-8">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
            <h2 className="text-xl mt-4">Loading...</h2>
          </div>
        ) : (
          <>
            <div className="flex flex-col md:flex-row">
              {/* LeftPanel on the left */}
              {location.pathname === '/' && (
                <div className="flex-shrink-0 w-full md:w-64">
                  <LeftPanel
                    selectedDestinationId={selectedDestinationId}
                    setSelectedDestinationId={setSelectedDestinationId}
                    filteredDestinations={filteredDestinations}
                    setFilteredDestinations={setFilteredDestinations}
                    isCollapsed={isCollapsed}
                    setIsCollapsed={setIsCollapsed}
                  />
                </div>
              )}
              {/* Main content centered */}
              <div className="flex-1 flex flex-col justify-start p-2 md:ml-5">
                {location.pathname === '/' && (
                  <h1 className="text-left font-heading text-3xl text-orange-400 mb-6 w-full md:ml-40 sm:w-auto">
                    {selectedDestination ? selectedDestination.name + ' Packages' : 'Destination'}
                  </h1>
                )}
                <Routes>
                  <Route
                    path="/"
                    element={
                      selectedDestination ? (
                        <PackageList
                          packages={selectedDestination.packages}
                          isCollapsed={isCollapsed}
                        />
                      ) : (
                        <p className="text-gray-500">No Matching Destination</p>
                      )
                    }
                  />
                  <Route
                    path="/package/:title"
                    element={
                      <PackageDetails
                        destinations={
                          filteredDestinations.length > 0
                            ? filteredDestinations
                            : destinations
                        }
                      />
                    }
                  />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<ContactUs />} />
                </Routes>
              </div>
            </div>
          </>
        )}
      </div>
    </HelmetProvider>
  );
};

export default App;